import { Component } from '@angular/core';

@Component({
  selector: 'app-ordercompleted',
  templateUrl: './ordercompleted.component.html',
  styleUrl: './ordercompleted.component.scss'
})
export class OrdercompletedComponent {

}
